import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Check, MapPin, Instagram, Facebook } from 'lucide-react';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-196">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-197" />
  </svg>;
const IMG_GOLD_MEMBERSHIP = 'https://cdn.magicpatterns.com/uploads/ucpYfHPidASvk5JsBdRuZi/dejame_esta_foto_mas_nitida_y__Nano_Banana_2_87396.png';
const PHOTO_4 = 'https://cdn.magicpatterns.com/uploads/cjFsXt9NS8WBfymUJdC4zp/dejame_esta_foto_mas_nitida_y__Nano_Banana_2_44669.png';
const PHOTO_7 = 'https://cdn.magicpatterns.com/uploads/nKRA5NPWRpuTqmP758EhXV/quita_todo_el_fondo_amarillo_y_Nano_Banana_2_37039.png';
interface MembershipCardProps {
  badge: string;
  title: string;
  subtitle: string;
  image: string;
  features: string[];
  price: string;
  whatsappMessage: string;
  isPopular?: boolean;
}
function MembershipCard({
  badge,
  title,
  subtitle,
  image,
  features,
  price,
  whatsappMessage,
  isPopular
}: MembershipCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className={`relative bg-deepblack border rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all ${isPopular ? 'border-gold border-2 shadow-gold-glow-lg md:scale-110' : 'border-gold'}`} data-id="element-198">
      {isPopular && <div className="absolute top-4 right-4 bg-gold text-deepblack px-3 py-1 rounded-full text-xs font-bold z-10" data-id="element-199">
          ¡MÁS POPULAR!
        </div>}
      <div className="p-6" data-id="element-200">
        <div className="text-2xl mb-2" data-id="element-201">{badge}</div>
        <h3 className="font-serif text-2xl font-bold text-bone mb-1" data-id="element-202">
          {title}
        </h3>
        <p className="text-gold text-sm mb-4" data-id="element-203">{subtitle}</p>

        <div className={`rounded-lg overflow-hidden mb-6 border-2 border-gold/50 bg-deepblack ${isPopular ? 'aspect-[16/10]' : 'h-48'}`} data-id="element-204">
          <img src={image} alt={title} className={`w-full h-full object-cover ${isPopular ? 'object-center' : ''}`} data-id="element-205" />
        </div>

        <div className="space-y-3 mb-6" data-id="element-206">
          {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-207">
              <Check className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-208" />
              <span className="text-bone text-sm" data-id="element-209">{feature}</span>
            </div>)}
        </div>

        <div className="text-gold text-3xl font-bold mb-4" data-id="element-210">{price}</div>

        <a href={`https://wa.me/573028281216?text=${encodeURIComponent(whatsappMessage)}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-gold text-deepblack py-3 rounded-full font-bold hover:bg-yellow-500 transition-colors" data-id="element-211">
          <WhatsAppIcon data-id="element-212" />
          Quiero esta Membresía
        </a>

        <div className="flex items-center gap-2 text-bone/60 text-xs mt-4 justify-center" data-id="element-213">
          <MapPin className="w-4 h-4" data-id="element-214" />
          Cra 71F # 64-15 Sur
        </div>
      </div>
    </motion.div>;
}
export function Membresias() {
  const memberships = [{
    badge: '🥉',
    title: 'BRONZE',
    subtitle: 'Corte Americano o Clásico',
    image: PHOTO_7,
    features: ['4 Cortes tipo Americano o Clásico', 'Incluye línea', 'Cejas opcional'],
    price: '$39.000 COP',
    whatsappMessage: 'Hola, me interesa la Membresía Bronze 🥉'
  }, {
    badge: '🥇',
    title: 'GOLD',
    subtitle: 'Corte y Barba',
    image: IMG_GOLD_MEMBERSHIP,
    features: ['3 Perfilados de Barba', '3 Cortes de cabello', 'Incluye línea y cejas'],
    price: '$42.000 COP',
    whatsappMessage: 'Hola, me interesa la Membresía Gold 🥇',
    isPopular: true
  }, {
    badge: '🥈',
    title: 'SILVER',
    subtitle: 'Padre e Hijo',
    image: PHOTO_4,
    features: ['2 Cortes de Caballero', '2 Cortes de Niño', 'Cejas y línea opcional'],
    price: '$38.000 COP',
    whatsappMessage: 'Hola, me interesa la Membresía Silver 🥈'
  }];
  return <section id="membresias" className="py-20 bg-gradient-to-b from-deepblack to-black" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-217">
          <div className="text-gold text-sm font-bold tracking-widest uppercase mb-4" data-id="element-218">
            MEMBRESÍAS EXCLUSIVAS
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-bone mb-6" data-id="element-219">
            La Forma Inteligente de Verse Bien
          </h2>
          <p className="text-bone text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-220">
            Ahorra sin olvidar tu LOOK. Los únicos en Bogotá Sur con membresías
            para caballeros y niños.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-221">
          {memberships.map((membership, index) => <MembershipCard key={index} {...membership} data-id="element-222" />)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-223">
          <p className="text-bone mb-4" data-id="element-224">Síguenos para ver más trabajos:</p>
          <div className="flex justify-center gap-4" data-id="element-225">
            <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gold/10 border border-gold text-gold px-6 py-3 rounded-full hover:bg-gold hover:text-deepblack transition-all" data-id="element-226">
              <Instagram className="w-5 h-5" data-id="element-227" />
              @barberiaelreybarba
            </a>
            <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gold/10 border border-gold text-gold px-6 py-3 rounded-full hover:bg-gold hover:text-deepblack transition-all" data-id="element-228">
              <Facebook className="w-5 h-5" data-id="element-229" />
              @Barberiaelreybarba
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}